import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import z from "./styles/index.cssr.js";
import R from "../../_mixins/use-config.js";
import u from "../../_mixins/use-theme.js";
import _ from "../styles/light.js";
import I from "../../_mixins/use-locale.js";
import b from "../../_internal/icons/Empty.js";
import { createKey as a } from "../../_utils/cssr/index.js";
import { useThemeClass as E } from "../../_mixins/use-css-vars-class.js";
import D from "../../_internal/icon/src/Icon.js";
import { defineComponent as P, computed as d, h as l } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const S = Object.assign(Object.assign({}, u.props), {
  description: String,
  showDescription: {
    type: Boolean,
    default: !0
  },
  showIcon: {
    type: Boolean,
    default: !0
  },
  size: {
    type: String,
    default: "medium"
  },
  renderIcon: Function
}), K = P({
  name: "Empty",
  props: S,
  slots: Object,
  setup(e) {
    const {
      mergedClsPrefixRef: n,
      inlineThemeDisabled: i,
      mergedComponentPropsRef: r
    } = R(e), p = u("Empty", "-empty", z, _, e, n), {
      localeRef: f
    } = I("Empty"), v = d(() => {
      var o, t, c;
      return (o = e.description) !== null && o !== void 0 ? o : (c = (t = r == null ? void 0 : r.value) === null || t === void 0 ? void 0 : t.Empty) === null || c === void 0 ? void 0 : c.description;
    }), h = d(() => {
      var o, t;
      return ((t = (o = r == null ? void 0 : r.value) === null || o === void 0 ? void 0 : o.Empty) === null || t === void 0 ? void 0 : t.renderIcon) || (() => l(b, null));
    }), m = d(() => {
      const {
        size: o
      } = e, {
        common: {
          cubicBezierEaseInOut: t
        },
        self: {
          [a("iconSize", o)]: c,
          [a("fontSize", o)]: y,
          textColor: g,
          iconColor: x,
          extraTextColor: C
        }
      } = p.value;
      return {
        "--n-icon-size": c,
        "--n-font-size": y,
        "--n-bezier": t,
        "--n-text-color": g,
        "--n-icon-color": x,
        "--n-extra-text-color": C
      };
    }), s = i ? E("empty", d(() => {
      let o = "";
      const {
        size: t
      } = e;
      return o += t[0], o;
    }), m, e) : void 0;
    return {
      mergedClsPrefix: n,
      mergedRenderIcon: h,
      localizedDescription: d(() => v.value || f.value.description),
      cssVars: i ? void 0 : m,
      themeClass: s == null ? void 0 : s.themeClass,
      onRender: s == null ? void 0 : s.onRender
    };
  },
  render() {
    const {
      $slots: e,
      mergedClsPrefix: n,
      onRender: i
    } = this;
    return i == null || i(), l("div", {
      class: [`${n}-empty`, this.themeClass],
      style: this.cssVars
    }, this.showIcon ? l("div", {
      class: `${n}-empty__icon`
    }, e.icon ? e.icon() : l(D, {
      clsPrefix: n
    }, {
      default: this.mergedRenderIcon
    })) : null, this.showDescription ? l("div", {
      class: `${n}-empty__description`
    }, e.default ? e.default() : this.localizedDescription) : null, e.extra ? l("div", {
      class: `${n}-empty__extra`
    }, e.extra()) : null);
  }
});
export {
  K as default,
  S as emptyProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/empty/src/Empty.js
// module id = 466
// module chunks = 41